export interface IRow {
    text: string;
    currentValue: number | string;
    currentValue2?: number | string;
    previousValue: number | string;
    previousValue2?: number | string;
}

export interface IHeaderRow {
    text: string;
    currentValue: string;
    currentValue2?: string;
    previousValue: string;
    previousValue2?: string;
    displayOpeningAndClosingValues: boolean;
}
export interface IFooterRow {
    text: string;
    currentValue: number;
    currentValue2?: number;
    previousValue: number;
    previousValue2?: number;
}
